export default function PaymentConfirmation() {
  return (
    <div className="min-h-screen bg-gradient-to-b from-stone-50 to-stone-100">
      {/* Header com Logo */}
      <header className="w-full py-6 px-4">
        <div className="max-w-4xl mx-auto flex justify-center">
          <img 
            src="https://static.readdy.ai/image/358c420565fea72b91269b0160885e8f/fa8ecd00f51449c785df99b2384d3dac.jpeg" 
            alt="Equilibrada Mente"
            className="h-16 w-auto object-contain"
          />
        </div>
      </header>

      {/* Título Principal */}
      <section className="max-w-3xl mx-auto px-6 pt-12 pb-8 text-center">
        <div className="inline-flex items-center justify-center w-20 h-20 bg-emerald-100 rounded-full mb-6">
          <i className="ri-checkbox-circle-fill text-4xl text-emerald-600"></i>
        </div>
        <h1 className="text-3xl md:text-4xl font-semibold text-stone-800 mb-4">
          Tudo certo. Sua jornada continua com segurança.
        </h1>
      </section>

      {/* Mensagem de Confirmação */}
      <section className="max-w-3xl mx-auto px-6 py-8">
        <div className="bg-white rounded-2xl shadow-sm p-8 md:p-10">
          <p className="text-lg text-stone-700 leading-relaxed">
            Recebemos a confirmação do seu pagamento e, a partir de agora, seu processo terapêutico segue de forma estruturada, segura e respeitando o seu tempo emocional.
          </p>
        </div>
      </section>

      {/* Mensagem de Acolhimento Emocional */}
      <section className="max-w-3xl mx-auto px-6 py-8">
        <div className="bg-emerald-50 rounded-2xl shadow-sm p-8 md:p-10 border border-emerald-100">
          <p className="text-lg text-stone-700 leading-relaxed mb-4">
            Continuar este tratamento é um ato de coragem e autocuidado genuíno. Você está escolhendo priorizar sua saúde emocional, e isso merece ser reconhecido.
          </p>
          <p className="text-lg text-stone-700 leading-relaxed">
            Não há julgamento aqui. Não há pressa. Há apenas um espaço seguro, construído com respeito ao seu ritmo e às suas necessidades internas.
          </p>
        </div>
      </section>

      {/* O que acontece agora */}
      <section className="max-w-3xl mx-auto px-6 py-8">
        <div className="bg-white rounded-2xl shadow-sm p-8 md:p-10">
          <h2 className="text-xl font-semibold text-stone-800 mb-6">
            O que acontece agora
          </h2>
          <div className="space-y-5">
            <div className="flex items-start">
              <div className="flex-shrink-0 w-8 h-8 flex items-center justify-center bg-emerald-600 rounded-lg">
                <span className="text-white font-semibold text-sm">1</span>
              </div>
              <p className="ml-4 text-base text-stone-700 mt-1">
                A próxima sessão será liberada no seu painel no momento adequado, respeitando o intervalo terapêutico necessário para integração dos exercícios
              </p>
            </div>
            <div className="flex items-start">
              <div className="flex-shrink-0 w-8 h-8 flex items-center justify-center bg-emerald-600 rounded-lg">
                <span className="text-white font-semibold text-sm">2</span>
              </div>
              <p className="ml-4 text-base text-stone-700 mt-1">
                O acompanhamento segue de forma progressiva e personalizada, considerando sua participação e evolução emocional
              </p>
            </div>
            <div className="flex items-start">
              <div className="flex-shrink-0 w-8 h-8 flex items-center justify-center bg-emerald-600 rounded-lg">
                <span className="text-white font-semibold text-sm">3</span>
              </div>
              <p className="ml-4 text-base text-stone-700 mt-1">
                Cada etapa respeita seu ritmo emocional e seus limites internos, sem forçar processos ou acelerar o que precisa de tempo
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Reforço de Segurança */}
      <section className="max-w-3xl mx-auto px-6 py-8">
        <div className="bg-white rounded-2xl shadow-sm p-8 md:p-10">
          <h2 className="text-xl font-semibold text-stone-800 mb-6">
            Segurança e confidencialidade
          </h2>
          <ul className="space-y-4">
            <li className="flex items-start">
              <div className="flex-shrink-0 w-6 h-6 flex items-center justify-center mt-0.5">
                <i className="ri-shield-check-line text-xl text-emerald-600"></i>
              </div>
              <span className="ml-3 text-base text-stone-700">
                Todo o processo é confidencial e protegido por sigilo profissional
              </span>
            </li>
            <li className="flex items-start">
              <div className="flex-shrink-0 w-6 h-6 flex items-center justify-center mt-0.5">
                <i className="ri-heart-pulse-line text-xl text-emerald-600"></i>
              </div>
              <span className="ml-3 text-base text-stone-700">
                O acompanhamento é estruturado com base em critérios clínicos e terapêuticos
              </span>
            </li>
            <li className="flex items-start">
              <div className="flex-shrink-0 w-6 h-6 flex items-center justify-center mt-0.5">
                <i className="ri-user-heart-line text-xl text-emerald-600"></i>
              </div>
              <span className="ml-3 text-base text-stone-700">
                Você está sendo acompanhado profissionalmente em cada passo dessa jornada
              </span>
            </li>
          </ul>
        </div>
      </section>

      {/* Como Funciona o Método */}
      <section className="max-w-3xl mx-auto px-6 py-8">
        <div className="bg-white rounded-2xl shadow-sm p-8 md:p-10">
          <h2 className="text-xl font-semibold text-stone-800 mb-6">
            Como funciona o Método Equilibrada🧠Mente
          </h2>
          <p className="text-base text-stone-700 leading-relaxed mb-6">
            As sessões são liberadas de forma progressiva, seguindo uma lógica terapêutica que considera:
          </p>
          <ul className="space-y-4">
            <li className="flex items-start">
              <div className="flex-shrink-0 w-6 h-6 flex items-center justify-center mt-0.5">
                <i className="ri-time-line text-xl text-emerald-600"></i>
              </div>
              <span className="ml-3 text-base text-stone-700">
                O intervalo semanal necessário para que você possa integrar e assimilar os exercícios propostos
              </span>
            </li>
            <li className="flex items-start">
              <div className="flex-shrink-0 w-6 h-6 flex items-center justify-center mt-0.5">
                <i className="ri-emotion-line text-xl text-emerald-600"></i>
              </div>
              <span className="ml-3 text-base text-stone-700">
                Seu ritmo emocional e sua capacidade de absorção dos conteúdos terapêuticos
              </span>
            </li>
            <li className="flex items-start">
              <div className="flex-shrink-0 w-6 h-6 flex items-center justify-center mt-0.5">
                <i className="ri-stethoscope-line text-xl text-emerald-600"></i>
              </div>
              <span className="ml-3 text-base text-stone-700">
                Uma avaliação terapêutica cuidadosa do seu progresso e participação nas atividades
              </span>
            </li>
          </ul>
          <div className="mt-8 p-5 bg-stone-50 rounded-xl border border-stone-200">
            <p className="text-base text-stone-700 leading-relaxed">
              Esse cuidado não é burocracia. É parte do método clínico e existe para garantir <strong className="text-stone-800">segurança emocional, profundidade terapêutica e resultados consistentes</strong>.
            </p>
          </div>
        </div>
      </section>

      {/* Mensagem Terapêutica Final */}
      <section className="max-w-3xl mx-auto px-6 py-8">
        <div className="text-center py-8">
          <p className="text-2xl text-stone-800 font-medium leading-relaxed mb-4">
            Este tratamento não é sobre pressa.
          </p>
          <p className="text-xl text-stone-700 leading-relaxed mb-3">
            É sobre cuidado genuíno, reconstrução emocional e estabilidade interna.
          </p>
          <p className="text-xl text-stone-700 leading-relaxed mt-6">
            Você está no caminho certo.
          </p>
        </div>
      </section>

      {/* Rodapé Profissional */}
      <footer className="max-w-3xl mx-auto px-6 py-12 pb-16">
        <div className="text-center border-t border-stone-200 pt-10">
          <p className="text-lg font-semibold text-stone-800 mb-2">
            Reginaldo Silva
          </p>
          <p className="text-base text-stone-600 mb-1">
            Psicoterapeuta Clínico
          </p>
          <p className="text-sm text-stone-500">
            Especialista em Hipnose Clínica, Psicanálise, PNL e princípios Neurociência
          </p>
        </div>
      </footer>
    </div>
  );
}